import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  TextField,
  Typography,
} from '@mui/material'
import * as yup from 'yup'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useEffect, useState } from 'react'
import { EditIcon } from 'src/v3/core/icons'
import { useFormik } from 'formik'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  fetchLinkedServiceRoster,
  selectLinkedServiceRosterByID,
  selectLinkedServiceRosterStatusByID,
  fetchLinkedServices,
  selectLinkedServiceById,
} from '../admin.slice'

export default () => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedServiceRoster = useAppSelector(
    selectLinkedServiceRosterByID(selectedLinkedService),
  )
  let linkedServiceRosterStatus = useAppSelector(
    selectLinkedServiceRosterStatusByID(selectedLinkedService),
  )
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )
  let [updatingUserCap, setUpdatingUserCap] = useState<boolean>(false)
  let [editingUserCap, setEditingUserCap] = useState<boolean>(false)

  let form = useFormik({
    validationSchema: yup.object({
      userCap: yup.number().integer().min(1).required(),
    }),
    enableReinitialize: true,
    initialValues: {
      userCap: linkedService?.userCap || 0,
    },
    onSubmit: (values) => {
      setUpdatingUserCap(true)
      axios
        .put('/api/admin/linked-service/user-cap', {
          id: selectedLinkedService,
          userCap: values.userCap,
        })
        .then(() => dispatch(fetchLinkedServices()))
        .then(() => setUpdatingUserCap(false))
        .then(() => form.resetForm())
        .catch((err) => {
          dispatch(
            errorMessageChanged(err?.message || 'Error Updating User Cap'),
          )
          dispatch(fetchLinkedServices())
          setUpdatingUserCap(false)
        })
    },
  })

  useEffect(() => {
    if (
      selectedLinkedService &&
      (!linkedServiceRosterStatus ||
        linkedServiceRosterStatus === 'uninitialized')
    ) {
      dispatch(fetchLinkedServiceRoster(selectedLinkedService))
    }
  }, [selectedLinkedService, linkedServiceRosterStatus])

  return (
    <Box sx={{ mt: 1, width: 200 }}>
      <Typography variant="caption" color="text.secondary">
        User Information
      </Typography>
      <Typography variant="subtitle2" sx={{ mt: 1 }}>
        Total Users: {linkedServiceRoster?.length ?? 0}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
        <Typography variant="subtitle2">
          User Cap: {linkedService?.userCap || 'None'}
        </Typography>
        <IconButton
          size="small"
          onClick={() => setEditingUserCap(!editingUserCap)}
        >
          <EditIcon />
        </IconButton>
      </Box>
      {editingUserCap && (
        <form onSubmit={form.handleSubmit}>
          <TextField
            sx={{ my: 1 }}
            variant="outlined"
            size="small"
            label="User Cap"
            name="userCap"
            type="text"
            fullWidth
            value={form.values.userCap}
            onChange={form.handleChange}
            error={form.touched.userCap && !!form.errors.userCap}
          />
          {!updatingUserCap ? (
            <Button type="submit" variant="contained" size="small">
              Update
            </Button>
          ) : (
            <CircularProgress size={30} />
          )}
        </form>
      )}
    </Box>
  )
}
